import { ICountry, IState } from '@checkout/state';
import { FieldProps } from 'formik';
import { get } from 'lodash';
import * as React from 'react';
import { ChangeEvent } from 'react';
import DropDown from '../DropDown/DropDown';

interface IOwnProps {
  id: string;
  label: string;
  options: any;
  valueSelector: (item: ICountry & IState) => string | undefined;
  onChange: (event: ChangeEvent<any>) => void;
}

const DropDownField: React.SFC<FieldProps<any> & IOwnProps> = ({
  field,
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  return (
    <DropDown
      {...field}
      {...props}
      touched={get(touched, field.name)}
      errors={get(errors, field.name)}
      onChange={(event: ChangeEvent<any>) => {
        if (props.onChange) {
          props.onChange(event);
        }
        field.onChange(event);
      }}
    />
  );
};

export default DropDownField;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/DropDownField/DropDownField.tsx